import { GET_DASHBOARD_DATA, GET_REQUESTED_SUBJECT, LOGIN_IMPERSONATE, RESET_PASSWORD, GET_OVER_SPEED_SOCKET, GET_STUDENT_ATTENDANCE_DATA, GET_MAINTENANCE_STATUS, RESET_DASHBOARD_DATA, GET_DRIVER_ATTENDANCE_DATA, GET_TRANSPORTATION_ALLOWANCE_DATA, GET_USER_TOKEN } from "../actions/DashboardActions";

  const initialState = { // initialize states
    Data: [],
    UserName: '',
    overSpeedData: [],
    studentAttendanceData: [],
    MaintenanceStatus:'',
    driverAttendanceData: [],
    transportationAllowanceData: [],
    userTokenData: [],
  };
  
  const DashboardReducer = function (state = initialState, action) {
    switch (action.type) {
      case GET_DASHBOARD_DATA: { // save dashboard data into state
        return { ...state, Data: (action.payload.data)?action.payload.data:[] };
      }
      case RESET_DASHBOARD_DATA: { // save dashboard data into state
        return { ...state, Data: [] };
      }
      case GET_REQUESTED_SUBJECT: {
        return { ...state, UserName: (action.payload.data)?action.payload.data: ''};
      }
      case GET_OVER_SPEED_SOCKET: {
        return { ...state, overSpeedData : (action.payload) ? [...state.overSpeedData, action.payload] : []};
      }
      case LOGIN_IMPERSONATE: {
        return { ...state,};
      }
      case RESET_PASSWORD: {
        return { ...state,};
      }
      case GET_STUDENT_ATTENDANCE_DATA: { // save dashboard student attendance chart data into state
        return { ...state, studentAttendanceData: (action.payload.data)?action.payload.data:[] };
      }
      case GET_MAINTENANCE_STATUS: {
        return { ...state, MaintenanceStatus: (action.payload.data)?action.payload.data: ''};
      }
      case GET_DRIVER_ATTENDANCE_DATA: { // save dashboard driver attendance chart data into state
        return { ...state, driverAttendanceData: (action.payload.data)?action.payload.data:[] };
      }
      case GET_TRANSPORTATION_ALLOWANCE_DATA: { // save dashboard transportation allowance chart data into state
        return { ...state, transportationAllowanceData: (action.payload.data)?action.payload.data:[] };
      }
      case GET_USER_TOKEN: { // save dashboard transportation allowance chart data into state
        return { ...state, userTokenData: (action.payload.data)?action.payload.data:[] };
      }
      default: {
        return {
          ...state,
        };
      }
    }
  };
  
  export default DashboardReducer;
  